import { createSelector } from 'reselect';

const getChunkId = (state, props) => props.chunkId.toString();
export const getBookmarks = (state) => state.bookmarks?.get('bookmarks');

export const makeGetChunkBookmark = () =>
  createSelector([getBookmarks, getChunkId], (bookmarks, chunkId) => {
    return bookmarks?.get(chunkId);
  });
